import { useEffect, useRef, useState } from 'react';
import StyledTextContainer from './StyledTextContainer';
import RenderHTML from './RenderHTML';
import TemplateVarSwitcher from '../templates/TemplateVarSwitcher';

export const AttachmentPreviewer = ({
  template,
  scale,
  onSelect,
  edit,
  scaleable,
  background,
  onClick,
  disableVariableRendering,
}) => {
  const zIndex = 10;

  const hoverHighlightClass =
    'hover:bg-green-100 hover:cursor-pointer transition-colors';
  const aspectRatio = 1 / Math.sqrt(2); // A4 aspect ratio

  return (
    <StyledTextContainer
      presetScale={scale}
      sx={{ zIndex: zIndex }}
      styleJson={template.styleJson}
      scaleable={scaleable}
      background={background}
      aspectRatio={aspectRatio}
      onClick={onClick}
      className
    >
      <RenderHTML
        onClick={() => onSelect('content')}
        className={'w-full  ' + (edit && hoverHighlightClass)}
        sx={{
          overflowY: 'auto!important',
          '::-webkit-scrollbar': {
            display: 'block',
            width: '0px',
          },
        }}
        HTML={
          disableVariableRendering
            ? template.content
            : TemplateVarSwitcher(template.content, template.vars)
        }
      />
    </StyledTextContainer>
  );
};
